// HeroSlider.jsx
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

const HeroSlider = () => {
    const [activeItem, setActiveItem] = useState(null);
    const [current, setCurrent] = useState(0);
    const [direction, setDirection] = useState(0);

    const slides = [
        {
            bg: "assets/imgs/banner/banner img 2.jpg",
            title: "Best Treatments Options by SQUARE MEDTRUST",
            subtitle: "Review and Choose Best Treatment Options Globally",
            grid: [
                { icon: "assets/imgs/treatment_icon/Stem_Cell_Therapy-transparent.png", label: "Stem Cell Therapy" },
                { icon: "assets/imgs/treatment_icon/PRP & SGC-PRP Therapy.png", label: "PRP & SGC-PRP Therapy" },
                { icon: "assets/imgs/treatment_icon/Anti-Aging Treatment.png", label: "Anti-Aging Treatment" },
                { icon: "assets/imgs/treatment_icon/NK Cell Therapy.png", label: "NK Cell Therapy" },
                { icon: "assets/imgs/treatment_icon/Immunotherapy.png", label: "Immunotherapy" },
                { icon: "assets/imgs/treatment_icon/Hearing & Speech.png", label: "Hearing & Speech" },
                { icon: "assets/imgs/treatment_icon/Ligament Rupture.png", label: "Ligament Rupture" },
                { icon: "assets/imgs/treatment_icon/Non-Androgenic Alopecia.png", label: "Non-Androgenic Alopecia" },
            ]
        },
        {
            bg: "assets/imgs/banner/slide 2 banner img.png",
            title: "World-Class Healthcare Services",
            subtitle: "Choose from the best hospitals worldwide",
            grid: [
                { icon: "assets/imgs/treatment_icon/Arthritis.png", label: "Arthritis" },
                { icon: "assets/imgs/treatment_icon/Convulsion.png", label: "Convulsion" },
                { icon: "assets/imgs/treatment_icon/Facial Muscle Spasms.png", label: "Facial Muscle Spasms" },
                { icon: "assets/imgs/treatment_icon/Migraine Nerve Decompression.png", label: "Migraine Nerve Decompression" },
                { icon: "assets/imgs/treatment_icon/Hyperbaric Oxygen Therapy.png", label: "Hyperbaric Oxygen Therapy" },
                { icon: "assets/imgs/treatment_icon/Diabetes Prevention.png", label: "Diabetics Prevention" },
                { icon: "assets/imgs/treatment_icon/Dentistry.png", label: "Dentistry" },
                { icon: "assets/imgs/treatment_icon/Target_Organ_Check-ups-transparent.png", label: "Target Organ Robotic Surgery" },
            ]
        }
    ];

    const slideVariants = {
        enter: (direction) => ({
            x: direction > 0 ? 1000 : -1000,
            opacity: 0
        }),
        center: {
            x: 0,
            opacity: 1
        },
        exit: (direction) => ({
            x: direction < 0 ? 1000 : -1000,
            opacity: 0
        })
    };

    const prevSlide = () => {
        setDirection(-1);
        setCurrent((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    };

    const nextSlide = () => {
        setDirection(1);
        setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    };

    const goToSlide = (index) => {
        setDirection(index > current ? 1 : -1);
        setCurrent(index);
    };

    const NavItem = ({ icon, label, index }) => (
        <div
            className={`group relative flex items-center gap-4 p-3 rounded-r-2xl cursor-pointer
                transition-all duration-300 ease-out hover:bg-white/20 hover:pr-8
                ${activeItem === index ? 'bg-white/25 pr-8' : 'bg-white/10'}`}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log(`Clicked on ${label}`);
            }}
            onMouseEnter={() => setActiveItem(index)}
            onMouseLeave={() => setActiveItem(null)}
        >
            <div className="w-11 h-11 transition-transform group-hover:scale-110 group-hover:rotate-6">
                <img 
                    src={icon} 
                    alt={label} 
                    className="w-full h-full object-cover"
                />
            </div>

            <span className="hidden md:block text-lg font-medium text-white group-hover:text-yellow-300">
                {label}
            </span>

            <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1 h-0 
                bg-gradient-to-b from-yellow-400 to-red-500 rounded-l-full
                transition-all duration-300 group-hover:h-3/4" />
        </div>
    );

    return (
        <div className="relative h-[85vh] overflow-hidden">
            <AnimatePresence initial={false} custom={direction}>
                <motion.section
                    key={current}
                    custom={direction}
                    variants={slideVariants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                    transition={{
                        x: { type: "spring", stiffness: 300, damping: 30 },
                        opacity: { duration: 0.2 }
                    }}
                    id="home"
                    className="absolute inset-0 flex items-center justify-start bg-cover bg-center bg-no-repeat text-white"
                    style={{ backgroundImage: `url("${slides[current].bg}")` }}
                >
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 via-blue-500/40 to-transparent" />

                    <div
                        className="absolute inset-0"
                        style={{
                            backgroundImage: `radial-gradient(circle at 20px 20px, rgba(255,255,255,0.05) 1px, transparent 0)`,
                            backgroundSize: "40px 40px",
                        }}
                    />

                    <div className="relative z-10 flex-1 flex items-center justify-center px-12">
                        <motion.div 
                            className="text-center"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2 }}
                        >
                            <h1 className="text-6xl font-bold text-white mb-4">
                                {slides[current].title}
                            </h1>
                            <p className="text-2xl text-white/90 mb-8">
                                {slides[current].subtitle}
                            </p>
                        </motion.div>
                    </div>

                    <motion.div 
                        className="absolute bottom-6 left-5 grid grid-cols-4 gap-4 col-span-6 mb-3"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, staggerChildren: 0.05 }}
                    >
                        {slides[current].grid.map((item, index) => (
                            <NavItem key={index} icon={item.icon} label={item.label} index={index} />
                        ))}
                    </motion.div>
                </motion.section>
            </AnimatePresence>

            {/* LEFT ARROW */}
            <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/40 text-white p-3 rounded-full hover:bg-black/60 z-50 transition-all hover:scale-110"
                type="button"
            >
                ❮
            </button>

            {/* RIGHT ARROW */}
            <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/40 text-white p-3 rounded-full hover:bg-black/60 z-50 transition-all hover:scale-110"
                type="button"
            >
                ❯
            </button>

            {/* DOTS */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-3 z-50">
                {slides.map((_, index) => (
                    <div
                        key={index}
                        onClick={() => goToSlide(index)}
                        className={`w-3 h-3 rounded-full cursor-pointer transition-all 
                        ${current === index ? "bg-white scale-125" : "bg-white/40 hover:bg-white/60"}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default HeroSlider;